// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DynamicPreview {
  width: 100%;
  height: 100%;
}
.DynamicPreview iframe {
  width: 800px;
  border: none;
  border-radius: 2px;
}
.DynamicPreview .hidden {
  display: none;
}
.DynamicPreview .LinearProgress-root {
  width: calc(100vw - 720px);
}
@media screen and (max-width: 1220px) {
  .DynamicPreview .LinearProgress-root {
    width: calc(100vw - 600px);
  }
}`, "",{"version":3,"sources":["webpack://./src/client/components/Modal/CompanyInformationModal/DynamicPreview/DynamicPreview.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;AACF;AACE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;AACJ;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,0BAAA;AADJ;AAEI;EAFF;IAGI,0BAAA;EACJ;AACF","sourcesContent":[".DynamicPreview {\n  width: 100%;\n  height: 100%;\n\n  iframe {\n    width: 800px;\n    border: none;\n    border-radius: 2px;\n  }\n\n  .hidden {\n    display: none;\n  }\n\n  .LinearProgress-root {\n    width: calc(100vw - 720px);\n    @media screen and (max-width: 1220px) {\n      width: calc(100vw - 600px);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
